<template>
  <div class="instFotoWrap" v-if="!hideThis">
    <div class="instFotoPreView">
      <div class="instPrviewBox">
        <img src="@/assets/images/passport1.png" alt="" v-if="imageData.length === 0 && fieldName === 'passport1'">
        <img src="@/assets/images/passport2.png" alt="" v-if="imageData.length === 0  && fieldName === 'passport2'">
        <img src="@/assets/images/self.png" alt="" v-if="imageData.length === 0  && fieldName === 'selfImage'">
        <img src="@/assets/images/bank.png" alt="" v-if="imageData.length === 0 && fieldName ===  'BankAccount'">
      </div>
      <div class="instFotoPreviewContent"
           v-bind:style="{'background-image':'url('+ imageData + ')'}"
      >

        <div class="instFotoPreviewLayerDone" v-show="imgDone">
          <img src="@/assets/vector/allDone.svg" svg-inline>
        </div>
        <div class="instFotoPreviewLayerFail" v-show="fieldStatus.code !== 0 && fieldStatus.ShowError">
          <img src="@/assets/vector/fail.svg" svg-inline>
        </div>
      </div>
    </div>
    <div class="instFotoAction">
      <p class="instFotoTitle">{{item.label}}</p>
      <p class="instFotoInfo">{{item.info}}</p>
      <p class="instErrMsg" v-if="fieldStatus.ShowError">{{ fieldStatus.msg }}</p>
      <div class="instActionInputWrap">
        <div>
          <input type="file" accept="image/*" v-on:change="previewImage">
          <p>Загрузить</p>
        </div>
        <div>
          <input type="file" accept="image/*" :capture="item.capture" v-on:change="previewImage">
          <p>Сделать фото</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataForInput from '@/store/Form/longFormOptions';
import {mapState} from "vuex";
export default {
  name: "instFotoAdd",
  props: {
    fieldName: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      item: DataForInput[this.fieldName],
      imageData: '',
      isLoadig:false,
      hideThis:false
    }
  },
  methods:{
    previewImage: function (event) {
      // Reference to the DOM input element
      this.imageData = '';
      let input = event.target;
      // let self = this;
      // Ensure that you have a file before attempting to read it
      if (input.files && input.files[0]) {
        // create a new FileReader to read this image and convert to base64 format
        let reader = new FileReader();
        // Define a callback function to run, when FileReader finishes its job
        reader.onload = async (e) => {
          // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
          // Read image as base64 and set to imageData
          if (e.target.result.includes('data:image')) {
            this.imageData = e.target.result;
            this.isLoadig = true;
            const result = await this.$store.dispatch('tryUploadFile', {
              fileName: this.fieldName,
              fileValue: e.target.result
            });
            if (result.execution) {
              this.$store.dispatch('saveSendData', {
                target: this.fieldName,
                value: result.fileId
              });
            } else {
              await this.$store.commit('saveWorkData', {
                target:this.fieldName,
                status:{
                  code:1,
                  msg:result.msg,
                  disable:false
                }
              });
              await this.$store.commit('saveErrorShow', {
                target:this.fieldName,
                value:true
              });
            }
            this.isLoadig = false

          }
        };
        // Start the reader job - read file as a data url (base64 format)
        reader.readAsDataURL(input.files[0]);
      }
    },
    hideIfIsset(){
      if (this.demandState.allPhotosStatusList[this.fieldName] > 0) {
        this.hideThis = true;
        this.$store.dispatch('saveSendData', {
          target: this.fieldName,
          value: this.demandState.allPhotosStatusList[this.fieldName]
        });
      }
    }
  },
  computed:{
    ...mapState({
      valueVuex: state => state.Form.sendData,
      statusVuex: state => state.Form.workData,
      demandState: state => state.instForm.demandState,
    }),
    imgDone(){
      return this.valueVuex[this.fieldName] > 0;
    },
    fieldStatus() {
      return this.statusVuex[this.fieldName];
    }
  },
  mounted() {
    console.log('fotoComponent mounted');
    this.hideIfIsset();
  }
}
</script>

<style scoped>
.instFotoWrap{
  background: var(--color-gray-type2);padding: var(--font-size-20) var(--font-size-14);
  display: flex;align-items: flex-start;justify-content: space-between;
  margin: 0 auto var(--font-size-16);border-radius: var(--font-size-04);
}
.instFotoPreView{width: var(--font-size-74);height: var(--font-size-100);background: white;position: relative;}
.instFotoPreviewContent{position: absolute;top:var(--font-size-02);left:var(--font-size-02);
  width: calc(100% - var(--font-size-04));height: calc(100% - var(--font-size-04));background-size: contain;
  background-position: center;background-repeat: no-repeat}
.instFotoPreviewContent div{position: absolute;top:0;left:0;width: 100%;height: 100%;display: flex;align-items: center;justify-content: center}
.instFotoPreviewContent div svg{width: var(--font-size-22);height:var(--font-size-22) }
.instFotoPreviewLayerDone{background: var(--color-green);opacity: 0.5}
.instFotoPreviewLayerFail{background: var(--color-red-type1);opacity: 0.5}
.instFotoAction{width: calc(100% - var(--font-size-74) - var(--font-size-14) )}
.instFotoTitle{font-weight: 500;font-size: var(--font-size-16);margin-bottom: var(--font-size-13)}
.instFotoInfo{font-size: var(--font-size-14);color:var(--color-gray-type3);margin-bottom: var(--font-size-13)}
.instActionInputWrap {display: flex;align-items: center;justify-content: space-between}
.instActionInputWrap div {position: relative;padding: var(--font-size-04);}
.instActionInputWrap div input{position: absolute;top:0;left:0;width: 100%;height: 100%;opacity: 0}
.instActionInputWrap div p{color:var(--color-dark-green);font-size: var(--font-size-16);pointer-events: none}
.instPrviewBox{display: flex;align-items: center;justify-content: center;height: 100%}
.instPrviewBox img{max-width: 100%}
</style>